import { memo } from 'react';
import { useHTMLMediaElementEvents } from '../../hooks/useHTMLMediaElementEvents';
import { VIDEO } from '../../../types/CallMediaTypes';
import { VideoElementWrapper } from './VideoElementWrapper';

/**
 * TODO: This is a base component for media elements that are used in the player.
 * Eventually we should use this for all media elements in the media player.
 * The old component tries to infer a lot of things from the URL, which this will
 * soon become a standard url with a redirect for all recordings.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const __HTMLMediaElement = ({
  crossOrigin,
  mediaRef,
  mediaType,
  recordingUrl,
  refreshRecordingUrl,
  status,
  videoPlayerOptions
}) => {
  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  const mediaElementEvents = useHTMLMediaElementEvents({
    refreshRecordingUrl
  });
  if (!recordingUrl) {
    return null;
  }
  if (mediaType === VIDEO) {
    return /*#__PURE__*/_jsx(VideoElementWrapper, Object.assign({
      videoPlayerOptions: videoPlayerOptions,
      recordingUrl: recordingUrl,
      mediaRef: mediaRef,
      status: status
    }, mediaElementEvents));
  }
  return /*#__PURE__*/_jsx("audio", Object.assign({
    crossOrigin: crossOrigin,
    "data-test-id": "mediaContext-audioElement",
    preload: "auto",
    ref: mediaRef
  }, mediaElementEvents, {
    children: /*#__PURE__*/_jsx("source", {
      src: recordingUrl,
      "data-test-id": "mediaContext-source"
    })
  }));
};
export const HTMLMediaElement = /*#__PURE__*/memo(__HTMLMediaElement);